import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import CanvasParabola from "../canvas/CanvasParabola";


const WrapperSvgStyled = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const PoseBorderForCamera = ({border}) => {
    const wrapperRef = useRef(null);

    const [containerWidth, s_containerWidth] = useState(0);
    const [containerHeight, s_containerHeight] = useState(0);

    useEffect(() => {
        if (wrapperRef.current) {
            setTimeout(()=>{
                // const parentElement = wrapperRef.current.parentElement;
                const parentElement = wrapperRef.current;
                if (parentElement) {
                    const width = parentElement.offsetWidth;
                    const height = parentElement.offsetHeight;
                    s_containerHeight(height);
                    s_containerWidth(width);
                }
            }, 0);
        }
    }, []);

    const dots = typeof border === 'object' ? border : {
        startY: 70,
        endY: 70,
        curve: 20
    };

    const normalizedDots = {
        startY: dots.startY / 100 * containerHeight,
        endY: dots.endY / 100 * containerHeight,
        curve: dots.curve / 100 * containerHeight,
    };

    return (
        <WrapperSvgStyled ref={wrapperRef}>
            <CanvasParabola
                width={containerWidth}
                height={containerHeight}
                detectSizes={true}
                background={"rgba(000,000,000, 0.0)"}
                dots={normalizedDots}
            />
        </WrapperSvgStyled>
    );
};

export default PoseBorderForCamera;